<div class="password-metter-container">
    <div [ngStyle]="step0 === '#FF3C3C' ? {'width': '40%', 'background-color': step0} :
     step1 === '#FFC828' ? {'width': '60%', 'background-color': step1} : 
     step2 === '#FFFF00' ? {'width': '80%', 'background-color': step2} :
     step3 === '#00BD82' ? {'width': '100%', 'background-color': step3} : {}" 
     class="password-metter-progress"></div>
</div>